import { Button, Link, Text, Tooltip, tokens } from '@fluentui/react-components';
import { MailRegular } from '@fluentui/react-icons';
import { useTranslation } from '../../i18n';
import type { SendGate } from './sendGate';

interface Props {
  gate: SendGate;
  onSend: () => void;
  /** Opens the review's Action Items tab, where a blocking item can be completed or cancelled. */
  onShowActionItems: () => void;
}

/**
 * The Send to Client quick action. When the gate is closed the reason is written ON THE PAGE under the
 * button, and the button stays focusable (`disabledFocusable`) so keyboard users reach the same reason
 * in its tooltip. A hover-only reason on an unfocusable control is what Elvia met on 2026-10-21.
 */
export function SendToClientAction({ gate, onSend, onShowActionItems }: Props) {
  const { t } = useTranslation();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXXS }}>
      <Tooltip content={gate.reason ?? t('reviewDetail.quick.sendHint')} relationship="description">
        <Button
          appearance="secondary"
          icon={<MailRegular />}
          onClick={gate.enabled ? onSend : undefined}
          disabledFocusable={!gate.enabled}
          style={{ justifyContent: 'flex-start' }}
        >
          {t('reviewDetail.quick.send')}
        </Button>
      </Tooltip>
      {!gate.enabled && gate.reason && (
        <Text data-testid="send-to-client-reason" size={200} style={{ color: tokens.colorNeutralForeground2 }}>
          {gate.reason}
          {gate.kind === 'open-actions' && (
            <>
              {' '}
              <Link as="button" onClick={onShowActionItems}>
                {t('sendGate.showActionItems')}
              </Link>
            </>
          )}
        </Text>
      )}
    </div>
  );
}
